import { render } from "./ongoing-court.vue?vue&type=template&id=47542b22"
import script from "./ongoing-court.vue?vue&type=script&lang=js"
export * from "./ongoing-court.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__